import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { servicesProviderExternalTaxDataSchema } from './ServicesProviderExternalTaxData.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';

class ServicesProviderExternalTax extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
    }
    validateData(data) {
        const result = servicesProviderExternalTaxDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderExternalTax.validation', `ServicesProviderExternalTax data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.EXTERNAL_TAX,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.EXTERNAL_TAX, ServicesProviderExternalTax);

export { ServicesProviderExternalTax };
//# sourceMappingURL=ServicesProviderExternalTax.js.map
